import { executeGet } from '../common/apiCaller'
import { GetSendingFlagMailSettingDto } from '../dto/facilityMailSettingDto'

const apiName = 'public'
const apiPath = '/facility-mail-setting'

export const executeGetSendingFlagMailSetting = (input?: GetSendingFlagMailSettingDto) => {
  return executeGet<GetSendingFlagMailSettingDto>(apiName, apiPath, input)
}
